interface FooterBannerProps {
  onOpenAffiliate: () => void;
}

export default function FooterBanner({ onOpenAffiliate }: FooterBannerProps) {
  const handleFloor = () => {
    const el = document.getElementById('floor');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const bannerItems = [
    {
      label: '系列店舗',
      image: 'https://readdy.ai/api/search-image?query=girls%20bar%20exterior%20Japan%2C%20light%20blue%20powder%20blue%20facade%2C%20elegant%20bar%20entrance%2C%20soft%20blue%20sign%20lighting%2C%20white%20and%20light%20blue%20color%20scheme%2C%20modern%20feminine%20bar%20design%2C%20inviting%20nighttime%20atmosphere%2C%20beautiful%20photography&width=800&height=400&seq=bnr_a1&orientation=landscape',
      onClick: onOpenAffiliate,
    },
    {
      label: '店舗写真',
      image: 'https://readdy.ai/api/search-image?query=girls%20bar%20interior%20Japan%2C%20light%20blue%20powder%20blue%20color%20scheme%2C%20elegant%20counter%20seats%2C%20soft%20blue%20ambient%20lighting%2C%20white%20and%20light%20blue%20decor%2C%20feminine%20cozy%20atmosphere%2C%20modern%20bar%20design%2C%20beautiful%20interior%20photography&width=800&height=400&seq=bnr_a2&orientation=landscape',
      onClick: handleFloor,
    },
  ];

  return (
    <section className="w-full grid grid-cols-2">
      {bannerItems.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={item.onClick}
          className="group relative overflow-hidden cursor-pointer block w-full text-left"
        >
          <div className="relative overflow-hidden" style={{ height: '160px' }}>
            <img
              src={item.image}
              alt={item.label}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.25)' }} />
            <div
              className="absolute bottom-0 left-0 w-full py-3 text-center"
              style={{ background: 'rgba(80,80,80,0.55)' }}
            >
              <p
                className="text-white text-sm md:text-base tracking-widest font-medium"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                {item.label}
              </p>
            </div>
          </div>
        </button>
      ))}
    </section>
  );
}
